<router-outlet></router-outlet>

<!-- Session Inactivity Timeout Warning Modal (5-minute idle compliance) -->
@if (idleService.isWarningVisible()) {
  <div class="fixed inset-0 z-9999 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-md animate-fade-in">
    <div class="relative w-full max-w-md bg-white rounded-3xl shadow-2xl border border-amber-200 overflow-hidden text-center p-6 md:p-8 animate-scale-up">
      <!-- Warning Badge -->
      <div class="w-16 h-16 mx-auto mb-4 rounded-2xl bg-amber-100 text-amber-600 flex items-center justify-center ring-8 ring-amber-50">
        <svg class="w-8 h-8 animate-bounce" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>

      <h3 class="text-xl font-black text-slate-900 tracking-tight">Session Inactivity Warning</h3>
      <p class="text-xs text-slate-500 mt-2 leading-relaxed">
        Your session has been idle for nearly 5 minutes. For security compliance, your session will automatically terminate in:
      </p>

      <!-- Countdown Display -->
      <div class="my-5 inline-flex items-center justify-center px-6 py-2.5 rounded-2xl bg-amber-50 border border-amber-200">
        <span class="text-3xl font-mono font-black text-amber-700 tracking-widest">
          00:{{ idleService.countdownSeconds() < 10 ? '0' + idleService.countdownSeconds() : idleService.countdownSeconds() }}
        </span>
        <span class="ml-2 text-xs font-bold text-amber-600 uppercase tracking-wider">sec</span>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-col sm:flex-row gap-3 mt-2">
        <button
          type="button"
          (click)="idleService.logoutNow()"
          class="flex-1 px-4 py-2.5 rounded-xl border border-slate-200 text-slate-700 hover:bg-slate-100 font-bold text-xs transition">
          Log Out Now
        </button>
        <button
          type="button"
          (click)="idleService.extendSession()"
          class="flex-1 px-4 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs shadow-md shadow-emerald-500/20 transition flex items-center justify-center gap-1.5">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Stay Logged In
        </button>
      </div>
    </div>
  </div>
}
